"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = exports.AuthController = void 0;
const api_1 = require("../api");
const AuthManager_1 = __importDefault(require("./AuthManager"));
const events_1 = require("../events");
const HandlerAsync_1 = __importDefault(require("../exceptions/HandlerAsync"));
const TokenExists_1 = __importDefault(require("../api/middlewares/TokenExists"));
const TokenNotExpired_1 = __importDefault(require("../api/middlewares/TokenNotExpired"));
const TokenVerified_1 = __importDefault(require("../api/middlewares/TokenVerified"));
/**
 * Classe per il controllo dell'autenticazione
 *
 * @export
 * @class AuthController
 * @extends {AuthManager}
 */
class AuthController extends AuthManager_1.default {
    constructor() {
        super(...arguments);
        /**
         * Return username for login
         *
         * @protected
         * @type {string}
         * @memberof Auth
         */
        this.username = 'email';
        /**
         * Prevent multiple refresh at same time
         *
         * @private
         * @type {null | Promise<void>}
         * @memberof Auth
         */
        this.waitRefreshToken = null;
    }
    /**
     * Esegue il login
     *
     * @param username
     * @param password
     * @returns Promise<IUser>
     * @throws UnauthorizedException, UnprocessableEntityException
     * @memberof AuthToken
     */
    async signin(username, password) {
        return new HandlerAsync_1.default(async () => {
            this.setAuthenticationAccessToken(await api_1.Api.post('auth/signin', { [this.username]: username, password, type: 'email' }));
            return await this.me().then(user => {
                events_1.Events.dispatch('auth:login', user);
                return user;
            });
        }, this.unsetAuthenticationAccessTokenIfErrorNotLegal.bind(this));
    }
    /**
     * Esegue il login  dopo aver ricevuro il codice da oauth
     *
     * @param type provider name
     * @param code provider temporany code
     * @returns Promise<IUser>
     * @throws UnauthorizedException, UnprocessableEntityException
     * @memberof AuthToken
     */
    async oauth(code, type) {
        return new HandlerAsync_1.default(async () => {
            this.setAuthenticationAccessToken(await api_1.Api.post('auth/signin', { type, code }));
            return await this.me().then(user => {
                events_1.Events.dispatch('auth:login', user);
                return user;
            });
        }, this.unsetAuthenticationAccessTokenIfErrorNotLegal.bind(this));
    }
    /**
     * Esegue la registrazione, l'utente deve essere confermato, per questo non lo restituisco
     *
     * @param username
     * @param password
     * @returns Promise<boolean>
     * @throws UnauthorizedException, UnprocessableEntityException
     * @memberof AuthToken
     */
    async signup(username, password, otherData = {}) {
        return new HandlerAsync_1.default(async () => {
            this.setAuthenticationAccessToken(await api_1.Api.post('auth/signup', { ...otherData, [this.username]: username, password, type: 'email' }));
            return true;
        }, this.unsetAuthenticationAccessTokenIfErrorNotLegal.bind(this));
    }
    /**
     * Rende inutilizzabile il vecchio token e rimuove l'utente
     *
     * @returns {Promise<void>}
     * @memberof Auth
     */
    async signout() {
        // return new ExceptionHandlerAsync(async () =>
        // Api.middleware([AuthMiddleware, RefreshExpiredTokenMiddleware], async () =>
        // Api.post('auth/logout').then(response => {
        this.unsetAuthenticationAccessToken();
        events_1.Events.dispatch('auth:logout');
        // return response
        // })
        // )
        // ) as Promise<void>
    }
    /**
     * Resetta la password per l'utente corrent
     *
     * @param new_password
     * @returns {Promise<boolean>}
     * @memberof Auth
     */
    async changePassword(old_password, new_password) {
        return new HandlerAsync_1.default(async () => api_1.Api.middleware([TokenVerified_1.default], async () => {
            await api_1.Api.post('auth/change-password', { old_password, new_password });
            return true;
        }, () => {
            this.unsetAuthenticationAccessTokenIfErrorNotLegal.bind(this);
            return false;
        }));
    }
    /**
     * Invia il link per email del reset della password
     *
     * @param email
     * @memberof Auth
     */
    sendPasswordResetLink(email) {
        return new HandlerAsync_1.default(async () => await api_1.Api.get('auth/password-reset', { email }));
    }
    /**
     * setta la nuova password
     *
     * @param reset the magic reset link
     * @param password the new password
     * @memberof Auth
     */
    passwordReset(reset, password) {
        return new HandlerAsync_1.default(async () => await api_1.Api.post('auth/password-reset', { reset, password }));
    }
    /**
     * Invia di nuovo l'email per confermare la registrazione
     *
     * @param confirm confirm code
     * @memberof Auth
     */
    sendConfirmEmail(email) {
        return new HandlerAsync_1.default(async () => await api_1.Api.get('auth/confirm-email', { email }));
    }
    /**
     * Conferma l'email per un nuovo utente
     *
     * @param confirm confirm code
     * @memberof Auth
     */
    confirmEmail(confirm) {
        return new HandlerAsync_1.default(async () => await api_1.Api.post('auth/confirm-email', { confirm }));
    }
    /**
     * Refresh del Token
     *
     * @returns Promise<void>
     * @throws TokenNotProvidedException, UnauthorizedException
     * @memberof AuthToken
     */
    async refresh() {
        if (this.waitRefreshToken)
            return this.waitRefreshToken;
        return (this.waitRefreshToken = new HandlerAsync_1.default(async () => api_1.Api.middleware([TokenVerified_1.default], async () => {
            const response = await api_1.Api.post('auth/refresh', this.getAuthenticationAccessToken().getAccessToken());
            this.setAuthenticationAccessToken(response);
            this.waitRefreshToken = null;
        }, this.unsetAuthenticationAccessTokenIfErrorNotLegal.bind(this))));
    }
    /**
     * Ritorna le informazioni sull'utente
     *
     * @returns Promise<IUser>
     * @throws TokenNotProvidedException, TokenExpireddException, UnauthorizedException
     * @memberof AuthToken
     */
    async me() {
        return new HandlerAsync_1.default(async () => {
            return this.setUser(await api_1.Api.middleware([TokenExists_1.default, TokenNotExpired_1.default], () => api_1.Api.get('v1/me')));
        }, this.unsetAuthenticationAccessTokenIfErrorNotLegal.bind(this));
    }
    /**
     * modifica l'utente [static]
     *
     * @returns Promise<IUser>
     * @throws TokenNotProvidedException, TokenExpireddException, UnauthorizedException
     * @memberof AuthToken
     */
    updateUser(user) {
        if (this.check()) {
            this.setUser(user);
        }
    }
    /**
     * Controlla se il token esiste (ma non se è valido)
     *
     * @returns boolean
     * @memberof AuthToken
     */
    hasToken() {
        return this.getAuthenticationAccessToken().exists();
    }
    /**
     * Controlla se l'utente è loggato
     *
     * @memberof AuthToken
     * @returns boolean
     */
    check() {
        return this.getAuthenticationAccessToken().isValid() && !!this.getUser();
    }
}
exports.AuthController = AuthController;
const Auth = new AuthController();
exports.Auth = Auth;
